import { Spin } from 'antd'
import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from '@/components/ProtectedRoute'

// import { PlatformProtectedRoute } from '@/components/PlatformProtectedRoute'

const Login = lazy(() => import('@/pages/Login'))
const Dashboard = lazy(() => import('@/pages/Dashboard'))
const Supplies = lazy(() => import('@/pages/Supplies'))
const SupplyDetail = lazy(() => import('@/pages/Supplies/Detail'))
const Demands = lazy(() => import('@/pages/Demands'))
const DemandDetail = lazy(() => import('@/pages/Demands/Detail'))
const Analytics = lazy(() => import('@/pages/Analytics'))
const Reports = lazy(() => import('@/pages/Reports'))
const Settings = lazy(() => import('@/pages/Settings'))
const Profile = lazy(() => import('@/pages/Profile'))
const FloorStrategies = lazy(() => import('@/pages/FloorStrategies'))
const FloorStrategyDetail = lazy(() => import('@/pages/FloorStrategies/Detail'))
const Deals = lazy(() => import('@/pages/Deals'))
const DealDetail = lazy(() => import('@/pages/Deals/Detail'))
const Finance = lazy(() => import('@/pages/Finance'))
const FinanceSettlementDetail = lazy(() => import('@/pages/Finance/SettlementDetail'))
// const Jobs = lazy(() => import('@/pages/Jobs')) // TODO: Create Jobs page

function Loading() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Spin size="large" />
    </div>
  )
}

export function AppRoutes() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplies"
          element={
            <ProtectedRoute>
              <Supplies />
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplies/:id"
          element={
            <ProtectedRoute>
              <SupplyDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/demands"
          element={
            <ProtectedRoute>
              <Demands />
            </ProtectedRoute>
          }
        />
        <Route
          path="/demands/:id"
          element={
            <ProtectedRoute>
              <DemandDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/floors"
          element={
            <ProtectedRoute>
              <FloorStrategies />
            </ProtectedRoute>
          }
        />
        <Route
          path="/floors/:id"
          element={
            <ProtectedRoute>
              <FloorStrategyDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/deals"
          element={
            <ProtectedRoute>
              <Deals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/deals/:id"
          element={
            <ProtectedRoute>
              <DealDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance"
          element={
            <ProtectedRoute>
              <Finance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance/settlements/:id"
          element={
            <ProtectedRoute>
              <FinanceSettlementDetail />
            </ProtectedRoute>
          }
        />

        {/* Platform admin only routes */}
        {/* TODO: Create Jobs page
        <Route
          path="/platform/jobs"
          element={
            <PlatformProtectedRoute>
              <Jobs />
            </PlatformProtectedRoute>
          }
        />
        */}

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
